import { LovefieldService } from './LovefieldService.js'

/* @ngInject */
export class TerrassorDB {
  /* @ngInject */
  constructor ($q) {
    this.$q = $q
    this.db = null
    this.tables = null
    this.loveField = LovefieldService;
  }

  /**
  * renvoie ttes les tables json; attachées à lf lors du démarrage (see bindAllJsonData)
  */
   getAllJsonTables(){
    return this.loveField.allJsonData.tables
   }

  /**
  * renvoit immédiatement le contenu d'une table stockée en JSON
  */
   getJsonTable(tName){

    var t = this.loveField.allJsonData.tables[tName];
    if(!t)
      console.log('not found jsonTable ', tName);
    return t;
   }

    /**
    * BC - 2019/04 - il est possible d'avoir des tables exo vides dans allJsonData - si on les as lues en base, on rempli
    **/
    setJsonTables(datas) {

    var tables = this.loveField.allJsonData.tables;
    var datables = datas.tables;
    if (!tables.exo_chantiers.length) {
        tables.exo_chantiers = datables.exo_chantiers;
        }
    if (!tables.exo_cubatures.length) {
        tables.exo_cubatures = datables.exo_cubatures;
        }
    if (!tables.exo_cubatures_exo_mouvements.length) {
        tables.exo_cubatures_exo_mouvements = datables.exo_cubatures_exo_mouvements;
        }
    if (!tables.exo_mouvements.length) {
        tables.exo_mouvements = datables.exo_mouvements;
        }
    }

  /*
  */
  readAllFromTable(tableName) {
     return this.getDbConnection()
    .then(db => {
                  var t = this.tables[tableName]
                  var query = db.select().from(t).exec()

                  return this.$q.resolve(query)
    })

  }

  /*
  *
  */
  getRowInTableImmediate(rowId, tableName) {

   var t =  this.getJsonTable(tableName)
   var items = t.filter(item => item.id == rowId);
   return items ? items.pop() : null
}
  /*
  *
  */
  getFirstRowInTableImmediate(tableName) {

   var t =  this.getJsonTable(tableName)
   var items = t.filter(item => item.id != -1);
   return items ? items.pop() : null
}

/*
* TODO; Voir dans les APixxx tous ce qu'on peut factoriser avec ça !!
*/
readRowInTable(rowId, tableName) {

  return this.getDbConnection()
  .then(db => {
    let table = this.tables[tableName]

    let query = db
        .select()
        .from(table)
        .where(table.id.eq(rowId))
        .exec();

      return this.$q.resolve(query)
      .then(resultsArray => {
        return resultsArray.pop()
      });
    });
  }    

/*
*
*/
    saveRowInTable (rowData, tableName) {
    //console.log('TerrassorDB::saveRowInTable', tableName, rowData)
    return this.getDbConnection()
    .then(db => {

      let table = this.tables[tableName]
      let row = table.createRow(rowData)

      let query = db
      .insertOrReplace()
      .into(table)
      .values([row])
      .exec()

      return this.$q.resolve(query)
    })
    .then(resultsArray => {
      var insertedRow = resultsArray.pop()
      //console.log('TerrassorDB::saveRowInTable done', tableName, insertedRow)
      //return this.$q.resolve(insertedRow)
      return insertedRow
    })
    .catch(e => {console.log('error saveRowInTable', e, rowData, tableName)})

  }


/*
*
*/
      deleteRowInTable (id, tableName) {
        console.log('TerrassorDB::deleteRowInTable', id, tableName)
  return this.getDbConnection()
    .then(db => {

      let table = this.tables[tableName]

      let query = db
      .delete()
      .from(table)
      .where(table.id.eq(id))
      .exec()

      return this.$q.resolve(query)
    })
    .catch(e => {console.log('error deleteRowInTable', e, rowData, tableName); return e})
}

/*
*
*/
truncate(tableName) {

return this.getDbConnection()
    .then(db => {

      let table = this.tables[tableName]

      let query = db
      .delete()
      .from(table)
      .exec()

      return this.$q.resolve(query)
    })
    .catch(e => {console.log('error truncate', e, tableName); return e})
}





  getDbConnection () {
          // Les références sur les tables sont accessibles depuis le service TerrassorDB

    this.tables = LovefieldService.refs
    if(this.db)
      return this.$q.resolve(this.db)
    else
        return LovefieldService.getDbConnection().then(db => {this.db = db;  return db})

  }

/*
*/
  delete() {
    console.log("TerrassorDB::delete")
    var request = window.indexedDB.deleteDatabase(TerrassorConst.DATABASE_NAME);
    request.onsuccess = function(e) {console.log("Base de données Terrassor supprimée")};
    request.onerror = function(e) {console.log("Erreur lors de la suppression de la BD Terrassor")};

  }
}



// WEBPACK FOOTER //
// ./src/client/common/db/TerrassorDB.js